<template>
  <van-overlay :show="show" :lock-scroll="false" z-index="999" class="iosGuideOverlay">
    <div class="iosGuidePanel" @click.stop @touchmove.stop>
      <div class="iosGuideNav">
        <div class="backBtn" @click="close">返回</div>
      </div>
      <div class="iosGuideScroll">
        <div class="brandHeader">
          <span class="brandName">花魁短剧</span>
          <span class="brandSub">轻量版安装引导</span>
        </div>

        <!-- STEP.1 -->
        <div class="stepBlock">
          <div class="stepHeader">
            <div class="headerRow">
              <span class="stepTitle">STEP.1</span>
              <span class="stepTag">步骤一</span>
            </div>
            <div class="stepDeco">
              <img class="stepDecoImg" :src="stepDecoImg" alt="" />
            </div>
          </div>
          <div class="stepCard">
            <div class="iosDialog">
              <div class="dialogBody">
                此网站正尝试下载一个配置描述文件。您要允许吗？
              </div>
              <div class="dialogDivider"></div>
              <div class="dialogActions">
                <div class="dialogAction">忽略</div>
                <div class="dialogActionDivider"></div>
                <div class="dialogAction dialogActionBold">允许</div>
              </div>
            </div>
            <p class="stepTip">点击安装花魁短剧轻量版出现安装证书</p>
          </div>
        </div>

        <!-- STEP.2 -->
        <div class="stepBlock">
          <div class="stepHeader">
            <div class="headerRow">
              <span class="stepTitle">STEP.2</span>
              <span class="stepTag">步骤二</span>
            </div>
            <div class="stepDeco">
              <img class="stepDecoImg" :src="stepDecoImg" alt="" />
            </div>
          </div>
          <div class="stepCard">
            <div class="iosScreen">
              <div class="iosNav">
                <span class="iosNavSide">取消</span>
                <span class="iosNavTitle">安装描述文件</span>
                <span class="iosNavSide iosNavBold">安装</span>
              </div>
              <div class="iosList">
                <div class="profileHeader">
                  <div class="appIconPlaceholder">
                    <img class="cogIcon" :src="cogImg" alt="" />
                  </div>
                  <div class="profileInfo">
                    <p class="profileName">花魁短剧</p>
                    <p class="profileDesc">亚洲最火成人网站</p>
                  </div>
                </div>
                <div class="iosListDivider"></div>
                <div class="profileMeta">
                  <div class="metaRow">
                    <span class="metaLabel">签署者</span>
                    <div class="metaValue">
                      <p>Apple Distribution: Cheng Wang (H3YVBP27D4)</p>
                      <p class="metaWarn">未验证</p>
                    </div>
                  </div>
                  <div class="metaRow">
                    <span class="metaLabel">描述</span>
                    <span class="metaText">花魁短剧</span>
                  </div>
                  <div class="metaRow">
                    <span class="metaLabel">包含</span>
                    <span class="metaText">Web Clip</span>
                  </div>
                </div>
                <div class="iosListDivider"></div>
                <div class="moreDetail">
                  <span>更多详细信息</span>
                  <span class="moreArrow">›</span>
                </div>
              </div>
              <div class="iosFooterAlert">移除已下载的描述文件</div>
            </div>
            <p class="stepTip">
              点击右上角 <span class="tipHighlight">「安装」</span> 进行下一步
            </p>
          </div>
        </div>

        <!-- STEP.3 -->
        <div class="stepBlock">
          <div class="stepHeader">
            <div class="headerRow">
              <span class="stepTitle">STEP.3</span>
              <span class="stepTag">步骤三</span>
            </div>
            <div class="stepDeco">
              <img class="stepDecoImg" :src="stepDecoImg" alt="" />
            </div>
          </div>
          <div class="stepCard">
            <div class="iosScreen">
              <div class="iosNav">
                <span class="iosNavSide">取消</span>
                <span class="iosNavTitle">同意</span>
                <span class="iosNavSide iosNavBold">下一步</span>
              </div>
              <div class="consentBody">
                <p class="consentFrom">来自 "花魁短剧" 的消息</p>
                <p class="consentText">花魁短剧</p>
              </div>
            </div>
            <p class="stepTip">
              点击右上角 <span class="tipHighlight">「下一步」</span>
            </p>
          </div>
        </div>

        <!-- STEP.4 -->
        <div class="stepBlock">
          <div class="stepHeader">
            <div class="headerRow">
              <span class="stepTitle">STEP.4</span>
              <span class="stepTag">步骤四</span>
            </div>
            <div class="stepDeco">
              <img class="stepDecoImg" :src="stepDecoImg" alt="" />
            </div>
          </div>
          <div class="stepCard">
            <div class="iosScreen">
              <div class="iosNav">
                <span class="iosNavSide">取消</span>
                <span class="iosNavTitle">警告</span>
                <span class="iosNavSide iosNavBold">安装</span>
              </div>
              <div class="warningBody">
                <p class="warningTitle">未验证的描述文件</p>
                <p class="warningText">不能验证 "花魁短剧" 的真实性</p>
              </div>
            </div>
            <p class="stepTip stepTipMulti">
              点击右上角 <span class="tipHighlight">「安装」</span> 进行下一步<br />
              并点击 <span class="tipDone">「完成」</span>
            </p>
          </div>
        </div>

        <!-- STEP.5 -->
        <div class="stepBlock">
          <div class="stepHeader">
            <div class="headerRow">
              <span class="stepTitle">STEP.5</span>
              <span class="stepTag">步骤五</span>
            </div>
            <div class="stepDeco">
              <img class="stepDecoImg" :src="stepDecoImg" alt="" />
            </div>
          </div>
          <div class="stepCard stepCardLast">
            <img class="finishIcon" :src="appIconImg" alt="花魁短剧" />
            <div class="finishText">
              <p class="finishTitle">回到桌面</p>
              <p class="stepTip">
                重新打开 <span class="tipBrand">[花魁短剧]</span> 即可开始使用
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </van-overlay>
</template>

<script>
export default {
  name: "IosInstallGuide",
  props: {
    show: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      stepDecoImg: require("@/assets/images/iosGuide/step-deco.png"),
      cogImg: require("@/assets/images/iosGuide/cog.png"),
      appIconImg: require("@/assets/images/iosGuide/app-icon.webp"),
    };
  },
  methods: {
    close() {
      this.$emit("close");
    },
  },
};
</script>

<style lang="scss" scoped>
.iosGuideOverlay {
  display: flex;
  align-items: stretch;
  justify-content: center;
}

.iosGuidePanel {
  width: 100%;
  height: 100%;
  max-height: 100%;
  background: #040910;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  position: relative;
}

.iosGuideNav {
  flex-shrink: 0;
  padding: 20px 20px 10px;
  background: #040910;
  z-index: 2;
}

.backBtn {
  display: inline-flex;
  align-items: center;
  padding: 4px 12px;
  border-radius: 6px;
  border: 1px solid rgba(255, 255, 255, 0.15);
  background: rgba(255, 255, 255, 0.1);
  color: #fff;
  font-size: 12px;
  font-weight: 500;
  line-height: normal;
}

.iosGuideScroll {
  flex: 1;
  min-height: 0;
  overflow-x: hidden;
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
  overscroll-behavior: contain;
  padding: 20px 20px 100px;
  display: flex;
  flex-direction: column;
  gap: 32px;
}

.brandHeader {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 4px;
  color: #fff;
  font-size: 22px;
  line-height: normal;
  padding-bottom: 12px;
  white-space: nowrap;

  .brandName {
    font-weight: 800;
  }

  .brandSub {
    font-weight: 700;
  }
}

.stepBlock {
  display: flex;
  flex-direction: column;
  gap: 16px;
  width: 100%;
}

.stepHeader {
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.headerRow {
  display: flex;
  align-items: center;
  gap: 8px;
}

.stepTitle {
  color: #fff;
  font-size: 22px;
  font-weight: 900;
  line-height: normal;
}

.stepTag {
  display: inline-flex;
  align-items: center;
  padding: 2px 8px;
  border-radius: 4px;
  background: linear-gradient(90deg, #f0b952 0%, #c6822b 100%);
  color: #000;
  font-size: 11px;
  font-weight: 700;
  line-height: normal;
}

.stepDeco {
  display: flex;
  align-items: center;
  width: 100%;
}

.stepDecoImg {
  display: block;
  height: 12px;
  width: auto;
}

.stepCard {
  width: 100%;
  box-sizing: border-box;
  padding: 16px;
  border-radius: 16px;
  border: 1px dashed #192430;
  background: #0c121a;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 16px;
}

.stepCardLast {
  gap: 20px;
}

.stepTip {
  width: 100%;
  margin: 0;
  color: #8699a6;
  font-size: 14px;
  font-weight: 500;
  line-height: 1.4;
  text-align: center;
}

.stepTipMulti {
  line-height: 1.5;
}

.tipHighlight {
  color: #2f80ed;
  font-weight: 700;
}

.tipDone {
  color: #00e676;
  font-weight: 700;
}

.tipBrand {
  color: #ff366e;
  font-weight: 700;
}

.iosDialog {
  width: 280px;
  border-radius: 14px;
  border: 1px solid #3f3f3f;
  background: rgba(30, 30, 30, 0.9);
  overflow: hidden;
  display: flex;
  flex-direction: column;

  .dialogBody {
    padding: 20px 16px;
    color: #fff;
    font-size: 15px;
    font-weight: 600;
    line-height: 1.35;
    text-align: center;
  }

  .dialogDivider {
    height: 1px;
    background: rgba(84, 84, 88, 0.4);
  }

  .dialogActions {
    display: flex;
    height: 44px;
  }

  .dialogAction {
    flex: 1;
    display: flex;
    align-items: center;
    justify-content: center;
    color: #2f80ed;
    font-size: 16px;
    font-weight: 400;
  }

  .dialogActionBold {
    font-weight: 600;
  }

  .dialogActionDivider {
    width: 1px;
    height: 100%;
    background: rgba(84, 84, 88, 0.4);
  }
}

.iosScreen {
  width: 280px;
  border-radius: 12px;
  border: 1px solid #1c1c1e;
  background: #000;
  overflow: hidden;
  display: flex;
  flex-direction: column;
}

.iosNav {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 10px 12px;
  background: #1c1c1e;
  font-size: 14px;
  line-height: normal;
  white-space: nowrap;

  .iosNavSide {
    color: #2f80ed;
    font-weight: 400;
  }

  .iosNavBold {
    font-weight: 600;
  }

  .iosNavTitle {
    color: #fff;
    font-weight: 600;
  }
}

.iosList {
  display: flex;
  flex-direction: column;
  gap: 12px;
  padding: 12px;
}

.profileHeader {
  display: flex;
  align-items: center;
  gap: 12px;
}

.appIconPlaceholder {
  width: 40px;
  height: 40px;
  border-radius: 8px;
  background: #2c2c2e;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}

.cogIcon {
  width: 24px;
  height: 24px;
  display: block;
  object-fit: contain;
}

.profileInfo {
  flex: 1;
  min-width: 0;

  .profileName {
    margin: 0;
    color: #fff;
    font-size: 14px;
    font-weight: 600;
    line-height: normal;
  }

  .profileDesc {
    margin: 2px 0 0;
    color: #8699a6;
    font-size: 11px;
    font-weight: 400;
    line-height: normal;
  }
}

.iosListDivider {
  width: 100%;
  height: 1px;
  background: #38383a;
}

.profileMeta {
  display: flex;
  flex-direction: column;
  gap: 6px;
  width: 100%;
  font-size: 11px;
  line-height: normal;
}

.metaRow {
  display: flex;
  align-items: flex-start;
  gap: 6px;
  width: 100%;
}

.metaLabel {
  width: 50px;
  flex-shrink: 0;
  color: #8699a6;
}

.metaValue {
  flex: 1;
  min-width: 0;

  p {
    margin: 0;
    color: #fff;
    word-break: break-all;
  }

  .metaWarn {
    margin-top: 2px;
    color: #ff3b30;
    font-weight: 600;
  }
}

.metaText {
  color: #fff;
}

.moreDetail {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  color: #fff;
  font-size: 12px;
  line-height: normal;

  .moreArrow {
    color: #8699a6;
    font-size: 14px;
  }
}

.iosFooterAlert {
  padding: 12px;
  background: #1c1c1e;
  color: #ff3b30;
  font-size: 12px;
  line-height: normal;
  text-align: center;
}

.consentBody {
  display: flex;
  flex-direction: column;
  gap: 8px;
  padding: 16px;
  width: 100%;
  box-sizing: border-box;

  .consentFrom {
    margin: 0;
    color: #8699a6;
    font-size: 11px;
    line-height: normal;
  }

  .consentText {
    margin: 0;
    color: #fff;
    font-size: 13px;
    line-height: normal;
  }
}

.warningBody {
  display: flex;
  flex-direction: column;
  gap: 8px;
  padding: 16px;
  width: 100%;
  box-sizing: border-box;

  .warningTitle {
    margin: 0;
    color: #8699a6;
    font-size: 12px;
    font-weight: 600;
    line-height: normal;
  }

  .warningText {
    margin: 0;
    color: #fff;
    font-size: 13px;
    line-height: normal;
  }
}

.finishIcon {
  width: 100px;
  height: 100px;
  border-radius: 18.75px;
  border: 1.563px solid #d73d2d;
  object-fit: cover;
  display: block;
  box-sizing: border-box;
}

.finishText {
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 6px;

  .finishTitle {
    margin: 0;
    color: #fff;
    font-size: 15px;
    font-weight: 600;
    line-height: normal;
  }
}
</style>
